export const ApiHttpPaths = {
  GET: {
    waterSystems: {
      americanStates: () => ({
        protected: false,
        url: '/epa/states',
      }),
      publicWaterSystems: (zips: string) => ({
        protected: false,
        url: `/epa/waterSystems/public?zips=${encodeURIComponent(zips)}`,
      }),
      wellWaterSystems: (zips: string) => ({
        protected: false,
        url: `/epa/waterSystems/wells?zips=${encodeURIComponent(zips)}`,
      }),
      publicWaterSystemsByAddress: (latitude: number, longitude: number, radius?: number) => ({
        protected: false,
        url: `/epa/waterSystems/public/byAddress?address[latitude]=${latitude}&address[longitude]=${longitude}${radius ? `&address[radius]=${radius}` : ''}`,
      }),      
      publicWaterSystemsByAddressComponent: (city: string, state: string, zipCode: string, address1: string) => ({
        protected: false,
        url: `/epa/waterSystems/public/byAddressComponents?city=${encodeURIComponent(city)}&state=${encodeURIComponent(state)}&zipCode=${encodeURIComponent(zipCode)}&address1=${encodeURIComponent(address1)}`,
      }),      
      publicWaterSystemMetrics: () => ({
        protected: false,
        url: `/epa/waterSystems/metrics/public`,
      }),
      wellWaterSystemMetrics: () => ({
        protected: false,
        url: `/epa/waterSystems/metrics/well`,
      }),
      mapPublicWaterSystemMetrics: () => ({
        protected: false,
        url: `/epa/waterSystems/metrics/map/public`,
      }),
      mapWellWaterSystemMetrics: () => ({
        protected: false,
        url: `/epa/waterSystems/metrics/map/well`,
      }),
      publicWaterSystemAggregates: (zoomLevel: string, stateCode?: string) => ({
        protected: false,
        url: `/epa/waterSystems/systems/public?zoomLevel=${encodeURIComponent(zoomLevel)}${stateCode ? `&stateCode=${encodeURIComponent(stateCode)}` : ''}`,
      }),
      wellWaterSystemAggregates: (zoomLevel: string, stateCode?: string, stateName?: string) => ({
        protected: false,
        url: `/epa/waterSystems/systems/well?zoomLevel=${encodeURIComponent(zoomLevel)}${stateCode ? `&stateCode=${encodeURIComponent(stateCode)}` : ''}${stateName ? `&stateName=${encodeURIComponent(stateName)}` : ''}`,
      }),
      UtilityDetails: (pwsid: string) => ({
        protected: false,
        url: `/epa/waterSystems/${pwsid}/contaminants/violations`,
      }),
    },
    waterTestStrips: {
      result: (jobId: string) => ({ 
        protected: false,
        url: `/epa/waterTestStrips/${jobId}`,
      }),
      
    },
    waterTestParams: {
      parameters: () => ({
        protected: false,
        url: `/epa/waterTestParams`
      }),
      parameterDetails: (paramName: string) => ({
        protected: false,
        url: `/epa/waterTestParams/${paramName}`,
      }),
    },
  },
  POST: {
    waterTestStrips: {
      upload: () => ({
        protected: false,
        url: '/epa/waterTestStrips',
      }),
      manualAnalyze: () => ({
        protected: false,
        url: '/water-test-strips/analysis',
        useAltServer: true,
      }),
      waterTestStripRequest: () => ({
        protected: false,
        url: '/water-test-strips',
        useAltServer: true
      }),
    },

    verification: {
      sendOtp: () => ({
        protected: false,
        url: '/water-test-strips/request-otp',
        useAltServer: true
      }),
      verifyOtp: () => ({
        protected: false,
        url: '/water-test-strips/verify-otp',
        useAltServer: true
      }),
      resendOtp: () => ({
        protected: false,
        url: '/water-test-strips/resend-otp',
        useAltServer: true
      }),
    },
  },
  PUT: {
    waterSystems: {
      publicWaterSystemCoordinates: () => ({
        protected: false,
        url: '/epa/waterSystems/coordinates/public',
      }),
      wellWaterSystemCoordinates: () => ({
        protected: false,
        url: '/epa/waterSystems/coordinates/well',
      }),
      wellWaterSystemGeoBlocks: () => ({
        protected: false,
        url: '/epa/waterSystems/geoblocks/well',
      })
    },
  },
  DELETE: {},
}
